"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackedBarChart = void 0;
var React = _interopRequireWildcard(require("react"));
var _highcharts = _interopRequireDefault(require("highcharts"));
var _highchartsMore = _interopRequireDefault(require("highcharts/highcharts-more"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _charts = require("../../../utils/charts");
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _ChartWrapper = require("../ChartWrapper");
var _StackedBarChartModule = _interopRequireDefault(require("./StackedBarChart.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
if (!!_highchartsMore.default && !!_highcharts.default && typeof _highchartsMore.default === 'function' && typeof _highcharts.default === 'object') {
  (0, _highchartsMore.default)(_highcharts.default);
}
const StackedBarChart = _ref => {
  let {
    series,
    isLoading,
    drilldown,
    emptyText,
    cardTitle,
    classNames,
    hasEmptyData,
    headerActions,
    customExportOptions,
    testId,
    ...userOptions
  } = _ref;
  const chartRef = React.useRef(null);
  const stackedBarSeries = series.map((seriesItem, index) => ({
    ...seriesItem,
    name: seriesItem.name,
    data: seriesItem.data,
    color: (0, _charts.getDataVizColor)(index),
    stacking: 'normal',
    pointWidth: _charts.columnPlotWidth
  }));
  const defaultStackedBarChartOptions = (0, _charts.getStackedBarChartOptions)();
  const stackedBarDrilldown = drilldown ? {
    ...drilldown,
    breadcrumbs: {
      floating: false
    }
  } : {};

  //$FlowFixMe[cannot-spread-inexact]
  const chartOptions = (0, _charts.mergeChartUserOptions)(defaultStackedBarChartOptions, {
    series: stackedBarSeries,
    drilldown: stackedBarDrilldown,
    ...userOptions
  });
  const {
    highChart,
    ...wrapperClassNames
  } = classNames || {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartWrapper.ChartWrapper, {
    ref: chartRef,
    title: cardTitle,
    isLoading: isLoading,
    emptyText: emptyText,
    classNames: wrapperClassNames,
    hasEmptyData: hasEmptyData,
    headerActions: headerActions,
    customExportOptions: customExportOptions,
    testId: testId,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_highchartsReactOfficial.default, {
      highcharts: _highcharts.default,
      containerProps: {
        className: (0, _classify.default)(_StackedBarChartModule.default.stackedBarChartContainer, highChart)
      },
      ref: chartRef,
      options: chartOptions
    })
  });
};
exports.StackedBarChart = StackedBarChart;